import { Component, ElementRef, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorPickerComponent),
      multi: true
    }
  ],
  standalone: false
})
export class ColorPickerComponent implements ControlValueAccessor, OnInit {
  
  @Input() control!: FormControl;
  @Input() label?: string;
  @Input() placeholder?: string;
  @ViewChild('colorInput') colorInput!: ElementRef;

  isFocused: boolean = false;
  selectedColor?: string;
  colors: string[] = [
    "#FFEA00", // Bright Yellow
    "#FFB300", // Bright Orange
    "#FF7F50", // Coral
    "#FF6347", // Tomato
    "#FF4500", // Orange Red
  
    "#FF85D1", // Light Pink
    "#FF1493", // Deep Pink

    "#3DDC84", // Bright Lime Green
    "#B2FF59", // Bright Chartreuse
    "#4CAF50", // Green
  
    "#00BFFF", // Deep Sky Blue
    "#5F9EA0", // Cadet Blue
    "#A3D2E0", // Powder Blue
  
    "#7B68EE", // Medium Slate Blue
    "#9B59B6", // Amethyst
    "#CDA4E3", // Light Purple

    "#D19A6A", // Light Chocolate
    "#80CED7"  // Bright Light Sea Green
  ];
  expanded: boolean = false;

  private onChange: (color: string) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {}

  ngOnInit() {
    if (this.control) {
      // Subscribe to control value changes to handle external updates
      this.control.valueChanges.subscribe((value) => {
        if (value !== this.selectedColor) {
          this.selectedColor = value;  // Update internal state
        }
      });
    }
  }

  // ControlValueAccessor methods
  writeValue(value: string): void {
    if (this.control && value !== this.control.value) {
      this.control.setValue(value, { emitEvent: false });
    }
    this.selectedColor = value;  // Update internal state
  }

  registerOnChange(fn: (color: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Optional: Handle disabled state
  }

  colorChange(color: string) {
    this.selectedColor = color;
    this.expanded = false;
    this.writeValue(this.selectedColor);
    this.onChange(this.selectedColor);
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement) {
      activeElement.blur();
    }
  }

  handleFocus() {
    this.isFocused = true;
    this.expanded = true;
    this.onTouched();
  }

  handleBlur() {
    this.expanded = false;
    this.isFocused = false;
  }
}